import styled from "styled-components";

export const MsgToastStyled = styled.div`
  .g-t-t {
    display: flex;

    align-items: flex-start;
    column-gap: 14px;
  }
.text_toast{
  display: flex;
  flex-direction: column;
  gap: 8px;
  .text_top{
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }
  .text_bottom{
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
     color: ${({ theme }) => theme.COLORS.GRAY_23};
  }
}
`;
